<div *ngFor="let alert of alerts" class="{{cssClass(alert)}}">
  <a class="close" style="cursor: pointer; margin-right: 8px; text-decoration: none;" (click)="removeAlert(alert)">❌</a>
  <span [innerHTML]="alert.message"></span>
</div>
